/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_sucess': {
    width: 16,
    height: 16,
    viewBox: '0 0 18.601 16',
    data: '<path pid="0" data-name="Path 17825" d="M17.9.908L17.4.48a2.007 2.007 0 00-2.8.178L6.273 9.901 3.758 7.735a2.007 2.007 0 00-2.8.175l-.44.487a2.007 2.007 0 00.144 2.836l4.61 4.222a2.008 2.008 0 002.9-.154l9.946-11.557A2.008 2.008 0 0017.9.908z" _fill="#fff"/>'
  }
})
